export default "__VITE_ASSET__C487O9J4__"